module.exports = __webpack_public_path__ + "img/banner-signup.7ad17bb.avif";